export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_05.432a897c.mp4";